import PresEditorTooltip from './PresEditorTooltip'

export * from './PresEditorTooltip'
export default PresEditorTooltip
